<template>
    <div class="custom-container">
        <div class="common-flexbox custom-content" :class="{'footer-content': !getIsRFN()}">
            <div v-if="getIsRFN()" @click="openTechSupportForm()" class="cursor-pointer footer-label custom-label">
                {{ $t('footer.tech_support') }}
            </div>

            <div class="custom-label" v-if="getIsRFN()">
                <img class="researchFn_Logo" src="@/assets/images/RFN_Logo.svg"
                    alt="Researchfn logo"/>
            </div>

            <div class="custom-label" v-else>
              <img class="connectFn_Logo" src="@/assets/images/NRS_Logo.svg"
                    alt="Connectfn logo"/>  
            </div>
            
            <div v-if="!getIsRFN()" @click="openTechSupportForm()" class="cursor-pointer footer-label custom-label">
                {{ $t('footer.tech_support') }}
            </div>

            <div @click="openPrivacyPolicy()" class="cursor-pointer footer-label custom-label">
                {{ $t('footer.privacy_policy')}}
            </div>
          </div>
    </div>
</template>

<script setup>
import { GetPreferredLanguage, IsRFN } from '@/utils/helper';

// Define component name
defineOptions({
  name: 'ConnectfnFooter'
});

// Methods
const openTechSupportForm = () => {
  if (IsRFN()) {
    window.open('/contact-researchfn/', '_blank');
  } else {
    window.open('/nrs/home/#!/contact-us/tech-support', '_blank');
  }
};

const openPrivacyPolicy = () => {
  if (GetPreferredLanguage()) {
    window.open(`https:\/\/www.netroadshow.com/nrs/home/${GetPreferredLanguage()}/privacy-policy.html`, '_blank');
  } else {
    window.open('https:\/\/www.netroadshow.com/nrs/home/en-us/privacy-policy.html', '_blank');
  }
};

const getIsRFN = () => {
  return IsRFN();
};
</script>

<style>
.common-flexbox {
    width: auto;
    height: 100%;
    display: flex;
    line-height: 1;
    flex-direction: none;
    flex: 1;
}
.custom-container {
  height: 50px;
    width: 100%;
}
.custom-content {
  justify-content: center;
  align-items: center;
  padding: 0 16.666666666666668%;
  box-sizing: border-box;
}
.cursor-pointer {
  cursor: pointer;
}
.logo-container {
    height: 16px;
    display: flex;
    align-items: flex-start;
}

.connectFn_Logo {
  height: 16px;
  margin-top : 5px;
}

.researchFn_Logo {
  height: 36px;
  margin-top : 5px;
}

.footer-content {
  padding: 0;
}

.custom-label {
  color: #285298;
  font-size: 12px;
  text-decoration: underline;
  margin: 0 15px;
  font-weight: 500;
}
.custom-label a {
  color: #285298;
}

@media (max-width: 767px) {
  .footer-label {
    white-space: nowrap;
    margin: 0 0 14px !important;
  }

  .footer-content .footer-label {
    margin: 0 5px !important;
  }
}

</style>